import { apiClient } from '@/services/ApiClient.js'

export class PhoneSurveyAnswerService {
  static getSurvey(orderId, surveyId) {
    return apiClient
      .get('orders/' + orderId + '/phone-survey-answers/' + surveyId)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      })
  }
  static getSurveys(orderId) {
    return apiClient
      .get('orders/' + orderId + '/phone-survey-answers')
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      })
  }

  static updateAnswer(payload) {
    return apiClient
      .post('orders/' + payload.order_id + '/phone-survey-answers', payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
